import * as React from 'react';
import { st, classes } from './CoreDropdownOption.st.css';
import { createOptionLabelId } from '../../../../Dropdown/helpers';
export const CoreDropdownOption = (props) => {
    const { id, option, isSelected, isHovered, onClickHandler, onMouseEnterHandler, onMouseLeaveHandler, dataHook, unavailable, } = props;
    const { isDisabled: disabled, isSelectable: selectable, value, role, } = option;
    const hovered = !disabled && isHovered;
    const selected = !disabled && isSelected;
    const optionDisabled = !selectable || disabled || unavailable;
    const ariaProps = {
        role,
        'aria-disabled': optionDisabled,
        disabled: optionDisabled,
        ...(selectable && role === 'option' ? { 'aria-selected': selected } : {}),
    };
    return (React.createElement("div", { id: id, tabIndex: -1, className: st(classes.root, { disabled, selectable, hovered, selected }, props.className), "aria-labelledby": id && createOptionLabelId(id), "data-hook": dataHook, ...ariaProps, onClick: onClickHandler, title: value, onMouseEnter: onMouseEnterHandler, onMouseLeave: onMouseLeaveHandler, "aria-hidden": option['aria-hidden'] }, option.render(value)));
};
CoreDropdownOption.displayName = 'CoreDropdownOption';
//# sourceMappingURL=CoreDropdownOption.js.map